import { render, staticRenderFns } from "./u-tooltip-elevation-tile-lg.vue?vue&type=template&id=3fb50b47&scoped=true"
import script from "./u-tooltip-elevation-tile-lg.vue?vue&type=script&lang=js"
export * from "./u-tooltip-elevation-tile-lg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb50b47",
  null
  
)

export default component.exports